// Uygulama teması (kullanıcı bazlı) — MD-1: tercih üç değer: sistem | acik | koyu.
// «sistem» = işletim sisteminin / telefonun teması (prefers-color-scheme); sistem değişince
// panel anında geçer. Tercih hesapta da tutulur: Kullanici.KoyuMod NULL = sistem, 0 = açık, 1 = koyu.
// PrimeVue dark token'ları `.my-app-dark` selektörü ile döner (bkz. main.js darkModeSelector).

import depo from './depo'; // GF1: try/catch'li localStorage sarmalayıcısı (3. taraf iframe)
import { uiState } from "./uiState";

const LS_KEY = "hepyTema";
const MODLAR = ["sistem", "acik", "koyu"];

const mq = typeof window !== "undefined" && window.matchMedia
  ? window.matchMedia("(prefers-color-scheme: dark)")
  : null;

// Son uygulanan tercih + public sayfada açık zorlaması (KT0) — sistem değişim dinleyicisi
// yalnız tercih «sistem» ve zorlama yokken temayı değiştirir.
let aktifMod = "sistem";
let acikZorlandi = false;

export function sistemKoyuMu() {
  return !!(mq && mq.matches);
}

// {mod} ya da eski {koyu} biçimini {mod}'a çevirir (SistemLayout vb. eski çağıranlar {koyu} gönderir).
export function temaNormalize(t) {
  if (t && MODLAR.includes(t.mod)) return { mod: t.mod };
  if (t && typeof t.koyu === "boolean") return { mod: t.koyu ? "koyu" : "acik" };
  return { mod: "sistem" };
}

// DB KoyuMod (null/0/1/true/false) → tercih
export function temaDbden(koyuMod) {
  // DBNull JSON'da null gelir; beklenmeyen biçim (obje) de sistem sayılır.
  if (koyuMod === null || koyuMod === undefined || koyuMod === "" || typeof koyuMod === "object") return { mod: "sistem" };
  return { mod: koyuMod === true || koyuMod === 1 || koyuMod === "1" || koyuMod === "true" ? "koyu" : "acik" };
}

// tercih → DB KoyuMod (null = sistem)
export function temaDbye(t) {
  const { mod } = temaNormalize(t);
  return mod === "sistem" ? null : mod === "koyu";
}

export function etkinKoyuMu(t) {
  const { mod } = temaNormalize(t);
  return mod === "sistem" ? sistemKoyuMu() : mod === "koyu";
}

// Yalnız sınıfları uygular, localStorage'a YAZMAZ.
export function temaSiniflariniUygula(koyu) {
  const el = document.documentElement;
  if (koyu) {
    el.classList.remove("light-theme");
    el.classList.add("dark", "my-app-dark", "dark-theme");
  } else {
    el.classList.remove("dark", "my-app-dark", "dark-theme");
    el.classList.add("light-theme");
  }
  uiState.koyuTema = !!koyu; // KT3: tema.js buradan çağrılan HER yol (public zorlama dahil) tek noktadan yazar
}

// KT0: public rotada kaydetmeden açık göster (cihazın kayıtlı tercihi silinmesin).
export function acikZorla() {
  acikZorlandi = true;
  temaSiniflariniUygula(false);
}

// Tercihi uygula ve localStorage'a yaz.
export function temaUygula(t) {
  const n = temaNormalize(t);
  aktifMod = n.mod;
  acikZorlandi = false;
  temaSiniflariniUygula(etkinKoyuMu(n));
  temaKaydet(n);
}

export function temaKaydet(t) {
  try {
    depo.yaz(LS_KEY, JSON.stringify(temaNormalize(t)));
  } catch (e) { /* yoksay */ }
}

// localStorage'daki tercih; yoksa eski 'theme' anahtarı (dark/light); o da yoksa sistem.
export function kayitliTema() {
  try {
    const raw = depo.oku(LS_KEY);
    if (raw) return temaNormalize(JSON.parse(raw));
  } catch (e) { /* yoksay */ }
  const eski = depo.oku("theme");
  if (eski === "dark") return { mod: "koyu" };
  if (eski === "light") return { mod: "acik" };
  return { mod: "sistem" };
}

// Sistem teması değişince (ör. telefon 19:00'da koyuya geçti) anında uygula. Uygulamada WebView
// `change` olayını kaçırırsa öne gelişte (visibilitychange) yeniden ölçülür.
function sistemDegisti() {
  if (aktifMod !== "sistem" || acikZorlandi) return;
  const koyu = sistemKoyuMu();
  if (koyu !== uiState.koyuTema) temaSiniflariniUygula(koyu);
}
if (mq) {
  if (mq.addEventListener) mq.addEventListener("change", sistemDegisti);
  else if (mq.addListener) mq.addListener(sistemDegisti); // eski Safari
}
if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") sistemDegisti();
  });
}
